import { render, staticRenderFns } from "./OpenInvoice.vue?vue&type=template&id=ec89210c&scoped=true&"
import script from "./OpenInvoice.vue?vue&type=script&lang=js&"
export * from "./OpenInvoice.vue?vue&type=script&lang=js&"
import style0 from "./OpenInvoice.vue?vue&type=style&index=0&id=ec89210c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec89210c",
  null
  
)

export default component.exports